import GoogleMapClient from "./clients/GoogleMapClient";
import HudhudMapClient from "./clients/HudhudMapClient";
import {
  computeHeading,
  animateMarker,
  cancelMarkerAnimation,
  isInSaudi,
  allInSaudi,
} from "./geo";

export {
  computeHeading,
  animateMarker,
  cancelMarkerAnimation,
  isInSaudi,
  allInSaudi,
};

const CLIENTS = {
  GOOGLE: GoogleMapClient,
  HUDHUD: HudhudMapClient,
};

// Cache one ready-promise per provider so each SDK loads at most once.
const _cache = {};

/** The provider configured via env (upper-cased), defaulting to GOOGLE. */
export function configuredClientName() {
  return (process.env.VUE_APP_MAP_CLIENT || "GOOGLE").toUpperCase();
}

/**
 * Get a specific, loaded map client by name.
 * @returns {Promise<object>} resolves to the ready client.
 */
export function getMapClient(name) {
  let key = (name || "GOOGLE").toUpperCase();
  if (!CLIENTS[key]) {
    console.warn(`[maps] Unknown map client "${key}", falling back to GOOGLE.`);
    key = "GOOGLE";
  }
  if (!_cache[key]) {
    _cache[key] = new CLIENTS[key]().load();
  }
  return _cache[key];
}

/** Get the client configured via env. */
export function createMapClient() {
  return getMapClient(configuredClientName());
}

/**
 * Pick the client based on where the map needs to show things.
 * If HUDHUD is configured but the given points aren't all inside Saudi
 * Arabia (Hudhud's coverage area), fall back to GOOGLE so tiles still render.
 * Empty/omitted points keep the configured provider.
 *
 * @param {{lat:number,lng:number}[]} points
 * @returns {Promise<object>} resolves to the ready client.
 */
export function createMapClientForPoints(points) {
  let name = configuredClientName();
  if (
    name === "HUDHUD" &&
    Array.isArray(points) &&
    points.length > 0 &&
    !allInSaudi(points)
  ) {
    console.info(
      "[maps] Points fall outside Saudi coverage — using GOOGLE instead of HUDHUD."
    );
    name = "GOOGLE";
  }
  return getMapClient(name);
}
